import React, { useCallback } from "react";
import { Grid } from "@mui/material";
import RequestContactUpdateFormTitle from "@requestContactUpdate/components/RequestContactUpdateFormTitle";
import { Dialog, DialogLoadingPlaceholder } from "@shared/components";
import { useAppDispatch, useAppSelector, useMobileLayout } from "@app/hooks";
import { closeRequestContactUpdateDialog, resetRequestContactUpdateState } from "@requestContactUpdate/store/ducks";
import { requestContactUpdateSelector } from "@requestContactUpdate/store/selectors";
import { submitFormThunk } from "@requestContactUpdate/store/thunks";
import RequestContactUpdate from "./RequestContactUpdate";
import RequestContactUpdateControls from "./RequestContactUpdateControls";

const RequestContactUpdateDialog = () => {
  const { open, loading } = useAppSelector(requestContactUpdateSelector);
  const dispatch = useAppDispatch();

  const handleCloseDialog = useCallback(() => {
    dispatch(closeRequestContactUpdateDialog());
    dispatch(resetRequestContactUpdateState());
  }, [dispatch]);

  const handleSubmit = useCallback(() => {
    dispatch(submitFormThunk());
  }, [dispatch]);

  const isMobile = useMobileLayout();
  const shouldRenderControlsInActions = !isMobile;

  return (
    <Dialog
      onClose={handleCloseDialog}
      open={open}
      title="REQUEST CONTACT UPDATE"
      maxWidth="lg"
      fullWidth
      actions={
        shouldRenderControlsInActions ? (
          <RequestContactUpdateControls onSubmit={handleSubmit} loading={loading} />
        ) : undefined
      }
    >
      <Grid container spacing={isMobile ? 7.5 : 10}>
        <RequestContactUpdateFormTitle text="Need to make a change? Use this form to request updates to yourself or another account team member's information. After your request is submitted, we will reach out to you when a change is made or if further information is needed." />
        {loading ? (
          <Grid item xs={12}>
            <DialogLoadingPlaceholder testId="request-contact-update-loading-placeholder" />
          </Grid>
        ) : (
          <RequestContactUpdate />
        )}
        {!shouldRenderControlsInActions && (
          <Grid item xs={12}>
            <RequestContactUpdateControls onSubmit={handleSubmit} loading={loading} />
          </Grid>
        )}
      </Grid>
    </Dialog>
  );
};

export default RequestContactUpdateDialog;
